const size = {
  xs: '420px',
  sm: '769px',
  lg: '1200px',
 }
 
 const device = {
  xs: `(min-width: ${size.xs})`,
  sm: `(min-width: ${size.sm})`,
  lg: `(min-width: ${size.lg})`
 }

 export default device